import { Link } from "react-router-dom";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Motion";
import { CTABand } from "@/components/site/CTABand";
import { SERVICES } from "@/data/services";

const Row = ({ s }) => (
  <Reveal>
    <Link
      to={`/services/${s.slug}`}
      data-testid={`service-row-${s.slug}`}
      className="group grid gap-8 border-b border-[#E2ECEB] py-12 transition-colors duration-500 hover:border-[#D4AF37] md:grid-cols-12 lg:py-16"
    >
      <div className="overflow-hidden md:col-span-4">
        <img src={s.image} alt={s.title} className="aspect-[4/3] w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-105" />
      </div>
      <div className="md:col-span-7 md:col-start-6">
        <span className="font-display flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-[#0D9488]">
          <span className="h-2 w-2 rotate-45 bg-[#D4AF37]" />
          {s.verb} · {s.title}
        </span>
        <h2 className="font-display mt-5 text-3xl font-bold tracking-tight text-[#0D9488] transition-transform duration-500 group-hover:translate-x-2 lg:text-4xl">{s.tagline}</h2>
        <p className="mt-5 text-base leading-relaxed text-[#2D6A64]">{s.summary}</p>
        <span className="font-display mt-8 inline-flex items-center gap-3 border border-[#0D9488]/40 px-6 py-3.5 text-sm font-semibold text-[#0D9488] transition-colors duration-300 group-hover:border-[#D4AF37]" data-testid={`explore-${s.slug}`}>
          Explore {s.verb}
          <span className="transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden>→</span>
        </span>
      </div>
    </Link>
  </Reveal>
);

export default function Services() {
  return (
    <main data-testid="services-page">
      <PageHero
        eyebrow="Our Core Solutions"
        lines={["Simplifying HR.", "Amplifying Business."]}
        intro="From workforce and talent solutions to strategic HR leadership, KRIMZON brings together people, processes and digital capabilities to simplify the way you manage HR — so you can focus on growing your business."
        testId="services-hero"
      />
      <section className="mx-auto max-w-[1400px] px-6 pt-20 lg:px-12 lg:pt-28">
        <Reveal>
          <div className="flex flex-col gap-6 border-y border-[#D4AF37]/60 py-8 lg:flex-row lg:items-center lg:justify-between">
            <p className="font-display text-xl font-semibold text-[#0D9488] md:text-2xl">One Partner. Across People, HR & Leadership.</p>
            <nav className="flex flex-wrap items-center gap-x-5 gap-y-2" data-testid="verb-nav">
              {SERVICES.map((s, i) => (
                <span key={s.slug} className="flex items-center gap-5">
                  {i > 0 && <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]" />}
                  <Link to={`/services/${s.slug}`} className="font-display text-sm font-bold tracking-[0.25em] text-[#0D9488] transition-colors hover:text-[#074E48]" data-testid={`verb-link-${s.slug}`}>
                    {s.verb}
                  </Link>
                </span>
              ))}
            </nav>
          </div>
        </Reveal>
      </section>
      <section className="mx-auto max-w-[1400px] px-6 pb-20 lg:px-12 lg:pb-28">
        {SERVICES.map((s) => (
          <Row key={s.slug} s={s} />
        ))}
      </section>
      <CTABand title="Let's simplify HR. Together." cta="Talk to KRIMZON" />
    </main>
  );
}
